'use client';

import React from 'react';
import { Home, CheckCircle, AlertTriangle } from 'lucide-react';
import { MOCK_HOUSES } from './housesData';
import { StatCard } from '@/components/ui/Cards';


export default function HousesSummaryCards() {
  const total = MOCK_HOUSES?.length;
  const occupied = MOCK_HOUSES?.filter(h => h?.status === 'occupied')?.length;
  const available = MOCK_HOUSES?.filter(h => h?.status === 'available')?.length;
  const needsAttention = MOCK_HOUSES?.filter(h => ['cleaning', 'disinfection', 'maintenance']?.includes(h?.status))?.length;
  const totalCapacity = MOCK_HOUSES?.reduce((s, h) => s + h?.capacity, 0);
  const totalOccupancy = MOCK_HOUSES?.reduce((s, h) => s + h?.currentOccupancy, 0);
  const overallOccupancyPct = totalCapacity > 0 ? Math.round((totalOccupancy / totalCapacity) * 100) : 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
      <StatCard label="Total Houses" value={total} sub={`${occupied} occupied`} icon={Home} iconBg="#f0fdf4" iconColor="#15803d" />
      <StatCard label="Available" value={available} sub="ready for stocking" icon={CheckCircle} iconBg="#f0fdfa" iconColor="#0f766e" />
      <StatCard label="Overall Occupancy" value={`${overallOccupancyPct}%`} sub={`${totalOccupancy?.toLocaleString()} / ${totalCapacity?.toLocaleString()} birds`} icon={Home} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="Needs Attention" value={needsAttention} sub="cleaning / maintenance" icon={AlertTriangle} iconBg="#fff7ed" iconColor="#c2410c" alert={needsAttention > 0} alertVariant="warning" />
    </div>
  );
}
